import { render, staticRenderFns } from "./PageCounter.vue?vue&type=template&id=4b64c8d8&scoped=true&"
import script from "./PageCounter.vue?vue&type=script&lang=js&"
export * from "./PageCounter.vue?vue&type=script&lang=js&"
import style0 from "./PageCounter.vue?vue&type=style&index=0&id=4b64c8d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b64c8d8",
  null
  
)

export default component.exports